
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal, Button, Col, Row } from 'antd';
import { ControlOutlined } from '@ant-design/icons';

const ScChangelogModal = forwardRef(({ onOk, url }, ref) => 
{
    const [visible, setVisible] = useState(false);
    const [scrolledToBottom, setScrolledToBottom] = useState(false)

    let changelogBodyRef = React.createRef()

    let handleOk = () => {}

    let isScrolledToBottom = () => {
        let rv = false;
        let element = changelogBodyRef
        if(element.current !== null)
        {
            let offset = 25;
            let res = element.current.scrollHeight - element.current.scrollTop;
            rv = res >= element.current.clientHeight - offset && res <= element.current.clientHeight + offset
        }
        return rv
    }

    useImperativeHandle(ref, () => ({
        showModal: () => {
            setVisible(true);
        }
    }));

    useEffect(() => {
        if (changelogBodyRef?.current != null) {
            setTimeout(() => {
            setScrolledToBottom(isScrolledToBottom()) }, 250);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changelogBodyRef]);


    return (
    <Modal
      visible={visible}
      title={"Changelog"}
      okText="Ok"
      cancelText="Cancel"
      onOk={() => handleOk}
      onCancel={() => setVisible(false)}
      forceRender
      closable={false}
      destroyOnClose={true}
      width={700}
      autoFocus={false}
      footer={
        <>
        <div style={{left: 0}}>Leggere tutto per chiudere</div>
        <Button key="submit" disabled={!scrolledToBottom} type="primary" onClick={() => setVisible(false)}>
          Chiudi
        </Button>
        </>
      }
    >
        <div className='searchTab' style={{minHeight:"10rem"}}>
            <Row onScroll={() => {setScrolledToBottom(isScrolledToBottom())}} style={{maxHeight:"28rem", margin: "0 .5rem", overflowY: "auto"}} ref={changelogBodyRef}>
                <Col span={24}>
                <h4 style={{fontWeight: 500}}>Versione 1.0.0 - 31 Gennaio 2025</h4>
                <span>
                <b>Miglioramenti:</b>
                <ul>
                    <li style={{marginTop: ".5rem"}}> 
                        <b><ControlOutlined/> Produzione / Ordini</b><br/>
                        Aggiunta funzionalità "Invia email richiesta info". In questo modo, selezionando uno o più ordini, dalla tabella sottostante, è possibile inviare un'email di richiesta informazioni all'ufficio acquisti o ad altri colleghi<br/>
                        <img style={{marginTop: ".5rem", border: "1px solid lightgray", width: "-webkit-fill-available"}} alt="#" src="/img/changelogs/1001_A.png"/>
                    </li>
                </ul>
                </span>
                </Col>
            </Row>
            <Row style={{bottom:0}} gutter={64}>
                <Col span={4}></Col>
                <Col span={8}>
                    
                </Col>
                <Col span={8}>
                </Col>
                <Col span={4}></Col>
            </Row>
 
        </div>
    </Modal>
    );
})

export default ScChangelogModal